import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useFlags } from '@atlaskit/flag';
import { updatePartnerDetails } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { getFlagForError, getFlagForSuccess } from "../../../../utils/FlagUtils";
import EditableContent from "../../EditableContent";
import { getHoursOfOperationUpdatePayload } from "./HoursOfOperation.utils";
import HoursOfOperationForm from "./HoursOfOperationForm/HoursOfOperationForm";
import HoursOfOperationInformation from "./HoursOfOperationInformation/HoursOfOperationInformation";

const HoursOfOperation = props => {
  var _props$vendorLinks2;

  const [editMode, setEditMode] = useState(false);
  const [updatingPartnerDetails, setUpdatingPartnerDetails] = useState(false);
  const {
    showFlag
  } = useFlags();

  const handleSubmit = async data => {
    try {
      var _props$vendorLinks;

      setUpdatingPartnerDetails(true);
      await updatePartnerDetails(props.mpacBaseUrl, props.partnerId, getHoursOfOperationUpdatePayload(_objectSpread({
        initialSla: (_props$vendorLinks = props.vendorLinks) === null || _props$vendorLinks === void 0 ? void 0 : _props$vendorLinks.sla,
        initialTargetResponseTime: props.supportDetails.targetResponseTime,
        initialSupportHours: props.supportDetails.supportHours
      }, data)));
      showFlag(getFlagForSuccess('partner-hours-of-operation-patch-success', 'Update successful', 'Your changes have been saved.'));
      setEditMode(false);
    } catch (error) {
      showFlag(getFlagForError('partner-hours-of-operation-patch-failure', 'An unknown error occurred'));
      log.error('HoursOfOperation', "Failed to update partner support hours", {
        error
      });
    } finally {
      setUpdatingPartnerDetails(false);
      props.cancelPartnerDetailsAPI();
      props.reloadPartnerDetails();
    }
  };

  const resetForm = () => {
    setEditMode(false);
  };

  return /*#__PURE__*/React.createElement(EditableContent, {
    title: "Hours of Operation",
    readOnlyContent: HoursOfOperationInformation({
      supportDetails: props.supportDetails,
      vendorLinks: props.vendorLinks
    }),
    onCancel: resetForm,
    onEdit: () => {
      setEditMode(true);
    },
    editMode: editMode
  }, /*#__PURE__*/React.createElement(HoursOfOperationForm, {
    supportDetails: props.supportDetails,
    sla: (_props$vendorLinks2 = props.vendorLinks) === null || _props$vendorLinks2 === void 0 ? void 0 : _props$vendorLinks2.sla,
    onClose: () => setEditMode(false),
    onSubmit: handleSubmit,
    submitting: updatingPartnerDetails
  }));
};

export default HoursOfOperation;